module.exports = __webpack_public_path__ + "img/ico_send_video.f3ad3f1c.png";